import React from 'react';

function NumberField({
  label,
  value,
  onChange,
  prefix,
  suffix,
  min = 0,
  step = 1,
  helper
}) {
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      <div className="input-shell">
        {prefix && <span className="input-affix">{prefix}</span>}
        <input
          type="number"
          min={min}
          step={step}
          value={value}
          onChange={(event) => onChange(Number(event.target.value))}
        />
        {suffix && <span className="input-affix suffix">{suffix}</span>}
      </div>
      {helper && <small>{helper}</small>}
    </label>
  );
}

export default NumberField;